import { extractFilesPath, toSameOriginFilesUrl } from '~/utils/mediaUrl';

/**
 * Пара фон + цвет текста для плейсхолдера без фото (стабильно от UUID клиента).
 * Светлые приглушённые фоны и насыщенный тёмный текст — читаемость и спокойная палитра.
 */
const CLIENT_AVATAR_FALLBACK_SWATCHES = [
  { bg: '#E0ECFF', fg: '#1e3a8a' },
  { bg: '#EDE9FE', fg: '#4c1d95' },
  { bg: '#FCE7F3', fg: '#9d174d' },
  { bg: '#D1FAE5', fg: '#065f46' },
  { bg: '#CCFBF1', fg: '#115e59' },
  { bg: '#FEF3C7', fg: '#78350f' },
  { bg: '#FFE4E6', fg: '#9f1239' },
  { bg: '#E0F2FE', fg: '#0c4a6e' },
  { bg: '#F3E8FF', fg: '#6b21a8' },
  { bg: '#DCFCE7', fg: '#166534' },
  { bg: '#FFEDD5', fg: '#9a3412' },
  { bg: '#E2E8F0', fg: '#1e293b' },
  { bg: '#FEF9C3', fg: '#713f12' },
  { bg: '#DBEAFE', fg: '#1e40af' },
  { bg: '#FEE2E2', fg: '#991b1b' },
];

/**
 * @param {string} uuid
 * @returns {{ bg: string, fg: string }}
 */
export function uuidToClientAvatarFallbackSwatch(uuid) {
  const s = String(uuid || '').replace(/-/g, '');
  let hash = 0;
  for (let i = 0; i < s.length; i++) {
    hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
  }
  return CLIENT_AVATAR_FALLBACK_SWATCHES[hash % CLIENT_AVATAR_FALLBACK_SWATCHES.length];
}

/**
 * @param {string | null | undefined} imgAvatar slug, /files/... или полный URL
 * @param {string} [_apiBase] устарело — оставлено для совместимости вызовов
 * @returns {string | undefined}
 */
export function resolveClientAvatarImageSrc(imgAvatar, _apiBase) {
  const raw = typeof imgAvatar === 'string' ? imgAvatar.trim() : '';
  if (!raw) {
    return undefined;
  }

  const filesPath = extractFilesPath(raw);
  if (filesPath) {
    if (filesPath.startsWith('/files/avatar/')) {
      return filesPath;
    }
    return undefined;
  }

  if (/^https?:\/\//i.test(raw)) {
    return toSameOriginFilesUrl(raw) || raw;
  }

  const suffix = /\.[a-z0-9]+$/i.test(raw) ? '' : '.webp';
  return `/files/avatar/default/${encodeURIComponent(raw)}${suffix}`;
}

/**
 * Как UAvatar: до двух инициалов из alt-текста (имени).
 * @param {string} name
 * @returns {string}
 */
export function clientAvatarInitialsFromName(name) {
  const alt = typeof name === 'string' ? name.trim() : '';
  if (!alt) {
    return '';
  }
  return alt
    .split(/\s+/)
    .map((word) => word.charAt(0))
    .join('')
    .substring(0, 2)
    .toUpperCase();
}
